module.exports = __webpack_public_path__ + "undefined.png?9abae1f99d1b499e68f5d8f44ede88b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/undefined.png
// module id = 23
// module chunks = 0